module.exports = __webpack_public_path__ + "img/background.d1db0810.png";